import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import JoinUs from 'components/Layout/JoinUs';
import Navigation from 'components/Layout/Navigation';
import Footer from 'components/Profile/Footer';
import BottomInfoBlock from 'components/Layout/BottomInfoBlock';
import PromotionModal from 'components/Layout/PromotionModal';
import PromoBanner from 'components/Layout/PromoBanner';
import {
  toggleGetOff,
  toggleJoinUs,
  togglePromotion,
  captureCouponFromUrl,
} from 'reduxStore/appStatic/actions';
import { findCouponBanner, findManualPromo } from 'config';

class Layout extends React.Component {
  navbarCollapse = () => {};

  shouldShowPromotionModal = () => {
    // Promotion modal disabled
    return false;
  };

  componentDidMount() {
    const { showGetOff } = this.props.appStatic;
    const $ = window.$;

    // Layout wraps every route, so this catches a ?coupon= link no matter where it lands.
    this.props.captureCouponFromUrl();

    $('#close').click(function (e) {
      e.preventDefault();
      $('.hidden').toggleClass('open');
      $('#mainNav').toggleClass('mo');
    });

    // Add a small delay to ensure modal is fully rendered
    setTimeout(() => {
      if (this.shouldShowPromotionModal()) {
        console.log('Opening promotion modal');
        $('#promotionModal').modal('show');
      } else if (showGetOff) {
        console.log('Opening newsletter modal');
        $('#newsletter').modal('show');
      }
    }, 100);

    $('body').scrollspy({
      target: '#mainNav',
      offset: 75,
    });
    // Collapse Navbar
    this.navbarCollapse = function () {
      return;
      // Unreachable code intentionally kept for future use
      // eslint-disable-next-line no-unreachable
      if ($('#mainNav').offset().top ?? 0 > 5) {
        $('#mainNav').addClass('navbar-scrolled');
      } else {
        $('#mainNav').removeClass('navbar-scrolled');
      }
    };
    // Collapse now if page is not at top
    this.navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(this.navbarCollapse);
  }

  render() {
    return (
      <Fragment>
        <PromotionModal onHide={this.props.togglePromotion} />
        {/*<GetOff onHide={this.props.toggleGetOff} />*/}
        <JoinUs
          onHide={() => {
            this.props.toggleJoinUs();
            setTimeout(() => {
              this.navbarCollapse();
            });
          }}
          showJoinUs={false}
        />
        <Navigation showJoinUs={false} />
        <div className="site-content">{this.props.children}</div>
        <PromoBanner
          message={
            (
              findManualPromo(this.props.appStatic.pendingCoupon) ||
              findCouponBanner(this.props.appStatic.pendingCoupon)
            )?.message
          }
        />
        <BottomInfoBlock />
        <Footer />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  appStatic: state.appStatic,
});

export default connect(mapStateToProps, {
  toggleGetOff,
  toggleJoinUs,
  togglePromotion,
  captureCouponFromUrl,
})(Layout);
